const unitOptimizerLogEn = {
	unitOptimizerLogTable: 'Unit Optimizer Log',
	timestamp: 'Timestamp',
	tag: 'Tag',
	objective: 'Objective',
	state: 'State',
	name: 'Name',
	unitOptimizerLogEditForm: 'Unit Optimizer Log',
	basic: 'Basic',
	table_name: 'Table Name',
	description: 'Description',
	fields: 'Fields',
	type: 'Type',
	userGroup: 'User Group'
};

export default unitOptimizerLogEn;